/**
 * @file
 * Main menu functionality.
 */

((_) => {
  /**
   * Expand submenu functionality.
   *
   * @param {Element} submenuToggle
   *   The submenu toggle button element.
   */
  function expandSubMenu(submenuToggle) {
    const parent = submenuToggle.closest(".js-menu__item--main");
    const submenu = parent.querySelector(".js-menu__submenu--main");

    submenuToggle.classList.add("is-expanded");
    submenuToggle.setAttribute("aria-expanded", "true");
    submenu.style.display = "block";
  }

  /**
   * Contract submenu functionality.
   *
   * @param {Element} submenuToggle
   *   The submenu toggle button element.
   */
  function contractSubMenu(submenuToggle) {
    const parent = submenuToggle.closest(".js-menu__item--main");
    const submenu = parent.querySelector(".js-menu__submenu--main");

    submenuToggle.classList.remove("is-expanded");
    submenuToggle.setAttribute("aria-expanded", "false");
    submenu.style.display = "none";
  }

  /**
   * Handle submenu toggle interaction functionality.
   *
   * @param {Element} submenuToggle
   *   The submenu toggle button element.
   *
   * @param {Event} event
   *   The event listener.
   */
  function handleSubMenuToggleInteraction(submenuToggle, event) {
    const isExpanded = submenuToggle.classList.contains("is-expanded");
    const arrowUp = 38;
    const arrowDown = 40;

    if (event.type === "click") {
      if (!isExpanded) {
        expandSubMenu(submenuToggle);
      } else if (isExpanded) {
        contractSubMenu(submenuToggle);
      }
    } else if (event.type === "keydown") {
      if (event.keyCode === arrowUp) {
        if (isExpanded) {
          contractSubMenu(submenuToggle);
        }
      } else if (event.keyCode === arrowDown) {
        if (!isExpanded) {
          expandSubMenu(submenuToggle);
        }
      }
    }
  }

  /**
   * Initializes main menu submenu toggle functionality.
   */
  function init() {
    const submenuToggles = document.querySelectorAll(".js-menu__toggle");

    submenuToggles.forEach((currentSubmenuToggle) =>
      currentSubmenuToggle.addEventListener(
        "click",
        _.debounce((event) => {
          handleSubMenuToggleInteraction(currentSubmenuToggle, event);
        }, 150)
      )
    );

    submenuToggles.forEach((currentSubmenuToggle) =>
      currentSubmenuToggle.addEventListener(
        "keydown",
        _.debounce((event) => {
          handleSubMenuToggleInteraction(currentSubmenuToggle, event);
        }, 150)
      )
    );
  }

  init();
})(_);
